module.exports = __webpack_public_path__ + "static/img/3.84dc45c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/3.png
// module id = 1Mmw
// module chunks = 0